import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const SchoolsDropdownById = ({ schools, value, onChange }) => {
  const handleChange = (event) => {
    const selectedSchool = schools.find(
      (school) => school.school_id === event.target.value
    );
    onChange(selectedSchool);
  };

  return (
    <FormControl fullWidth margin="dense">
      <InputLabel>School</InputLabel>
      <Select value={value.school_id} onChange={handleChange} label="School">
        {schools.map((school) => (
          <MenuItem key={school.school_id} value={school.school_id}>
            {school.school_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SchoolsDropdownById;
